import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11f3df90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 mx-auto" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-10 pb-lg-15\" data-v-11f3df90><h2 class=\"fw-bold d-flex align-items-center text-dark\" data-v-11f3df90> Choose Verifcation Type <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" title=\"Billing is issued based on your selected account type\" data-v-11f3df90></i></h2><div class=\"text-gray-400 fw-semobold fs-6\" data-v-11f3df90> If you need more info, please check out <a href=\"https://morrisonrecordsbureau.com/contact-us/\" target=\"_blank\" class=\"link-primary fw-bold\" data-v-11f3df90>Help Page</a>. </div></div>", 1)
const _hoisted_6 = { class: "fv-row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_10 = { class: "d-block fw-semobold text-start" }
const _hoisted_11 = { class: "text-dark fw-bold d-flex flex-column flex-lg-row align-items-lg-start fs-4 mb-2" }
const _hoisted_12 = { class: "badge badge-primary ms-lg-3 my-3 my-lg-0 plan-price" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "per", -1))
const _hoisted_14 = { class: "text-gray-400 fw-semobold fs-6" }
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-semobold text-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark fw-bold d-block fs-4 mb-2" }, "Bulk Verifications"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-semobold fs-6" }, "Select this option for medium to heavy verification workloads typically between 1000 to 10,000 verifications")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ActiveSubscriptionCard = _resolveComponent("ActiveSubscriptionCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", {
                  class: _normalizeClass(["p-7 d-flex align-items-center mb-10 border rounded pointer text-hover-primary", { 'border-primary active': _ctx.isSingle }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectVerificationType(_ctx.IDVerificationType.SINGULAR)))
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg, { src: 'media/icons/duotune/communication/com005.svg' }, null, 8, ["src"])
                  ]),
                  _createElementVNode("span", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.basePlan?.name || "Single Verifications"), 1),
                      _createElementVNode("span", _hoisted_12, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.formatCurrency(
                            _ctx.getPlanPriceByCurrency(_ctx.basePlan, "usd"),
                            "usd"
                          )) + " ", 1),
                        _hoisted_13
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.basePlan?.detail ||
                      "If you need more info, please check it out"), 1)
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", {
                  class: _normalizeClass(["p-7 d-flex align-items-center border rounded pointer text-hover-primary", { 'border-primary active': _ctx.isBulk }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectVerificationType(_ctx.IDVerificationType.BULK)))
                }, [
                  _createElementVNode("span", _hoisted_16, [
                    _createVNode(_component_inline_svg, { src: 'media/icons/duotune/finance/fin006.svg' }, null, 8, ["src"])
                  ]),
                  _hoisted_17
                ], 2)
              ])
            ])
          ]),
          (_ctx.activeSubscription)
            ? (_openBlock(), _createBlock(_component_ActiveSubscriptionCard, {
                key: 0,
                subscription: _ctx.activeSubscription,
                note: `Via your active subscription, you have ${_ctx.remainingVerifications} verifications left`,
                onSelected: _ctx.selectSubscription
              }, null, 8, ["subscription", "note", "onSelected"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}